import { render, staticRenderFns } from "./ModalResetServer.vue?vue&type=template&id=47be1f58"
import script from "./ModalResetServer.vue?vue&type=script&lang=js"
export * from "./ModalResetServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports